/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */


/**
 * @author: Satyaki Bose
 * Shared Emotion cache for MUI styled()/sx.
 * speedy: true uses CSSOM insertRule in webpack DEV (same as production)
 * so first Dialog/Tab/Menu mount does not append many text <style> tags.
 * prepend: true keeps MUI injection order correct vs other CSS.
 */

import createCache from '@emotion/cache';

const muiCache = createCache({
  key: 'mui',
  prepend: true,
  speedy: true
});

export default muiCache;
